<div class="container py-5 text-center">

  <div class="card border-0 shadow-sm mx-auto" style="max-width: 520px;">
    <div class="card-body p-4">

      <div *ngIf="status === 'success'">
        <i class="fas fa-check-circle text-success fa-3x mb-3"></i>
        <h4>Correo verificado</h4>
        <p class="text-muted">
          Tu correo fue verificado correctamente. Ya puedes continuar usando SIPE.
        </p>
        <a routerLink="/login" class="btn btn-primary">
          Ir al inicio de sesión
        </a>
      </div>

      <div *ngIf="status !== 'success'">
        <i class="fas fa-exclamation-triangle text-warning fa-3x mb-3"></i>
        <h4>Enlace inválido o expirado</h4>
        <p class="text-muted">
          El enlace de verificación no es válido o ya venció. Solicita un nuevo enlace.
        </p>
        <a routerLink="/login" class="btn btn-outline-primary">
          Volver al inicio
        </a>
      </div>

    </div>
  </div>

</div>